import React, { useEffect, useState } from "react";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { Button, Table } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import ReportsAndDocumentsIcon from "mdi-react/FileDocumentOutlineIcon";
import DownloadIcon from "mdi-react/DownloadIcon";
import { useSelector } from "react-redux";
import fetchAttachmentData, {
  updateLinkURLNew,
  removeSpanTag,
  updateLinkURL,
} from "../../Utils";
import moment from "moment";
import Pagination from "react-bootstrap/Pagination";
import classes from "../../components/CommonGrid/commonGrid.module.css";
import { roleType } from "../../Utils/constant";
import { useAbortController } from "../../hooks/useAbortController";
import PopupWrapper from "../../components/PopupWrapper";
import CreateTicketWithAttachments from "../../components/CreateTicket/CreateTicketWithAttachments";
import { BlurWrapper } from "../../Utils/CustomComponent";

const AttachmentsTab = ({
  loanID,
  showUploadMore = true,
  loandetailsView = false,
}) => {
  const accountId = useSelector((state) => state.account.lenderId);
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const [attachments, setAttachments] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const isDemoAccount = useSelector((state) => state.account.isDemoAccount);
  const { signal } = useAbortController();

  useEffect(() => {
    const fetchAttachments = async () => {
      let resp;
      try {
        let url;
        if (
          selectedRole === roleType.broker ||
          selectedRole === roleType.brokerAdmin
        ) {
          url = loandetailsView
            ? urls.broker.getBrokerAttachments(loanID ? loanID : accountId)
            : urls.broker.getAttachments(loanID ? loanID : accountId);
        } else if (
          selectedRole === roleType.lender ||
          selectedRole === roleType.lenderAdmin
        ) {
          url = urls.lender.getAttachmentsLender(loanID ? loanID : accountId);
        } else if (selectedRole === roleType.borrower) {
          url = urls.broker.getAttachments(accountId);
        }
        const res = await axios.get(url, { signal });

        if (
          selectedRole === roleType.lender ||
          selectedRole === roleType.broker ||
          selectedRole === roleType.brokerAdmin ||
          selectedRole === roleType.lenderAdmin ||
          selectedRole === roleType.borrower
        ) {
          resp = res.data[0]?.map((data) => {
            const htmlObject = document.createElement("div");
            htmlObject.innerHTML = data.attachment;
            const titleValue = removeSpanTag(
              htmlObject?.getElementsByTagName("a")?.[0]?.innerHTML
            );
            const hrefValue = updateLinkURLNew(
              htmlObject?.getElementsByTagName("a")?.[0]?.getAttribute("href")
            );
            data.Attachment = { href: hrefValue, title: titleValue };
            return data;
          });
        } else {
          resp = res.data[0]?.map((data2) => {
            let htmlObject = document.createElement("div");
            htmlObject.innerHTML = data2.Attachment;
            const titleValue =
              htmlObject?.getElementsByTagName("a")?.[0]?.innerHTML;
            // const hrefValue = htmlObject
            //   ?.getElementsByTagName("a")?.[0]
            //   ?.getAttribute("href");
            const hrefValue = updateLinkURL(
              `${htmlObject
                ?.getElementsByTagName("a")?.[0]
                ?.getAttribute("href")}/1`
            );
            data2.Attachment = { href: hrefValue, title: titleValue };

            const modifiedData2 = {
              ...data2,
              date: data2.Date,
            };

            return modifiedData2;
          });
        }

        const filterAttachmentsByTitle = (title) =>
          resp.filter((item) =>
            item["Attachment"]?.title
              ?.toLowerCase()
              ?.includes(title.toLowerCase())
          );

        const attachmentCategories = [
          { title: "Statement Of Account", filter: "Statement" },
        ];

        if (!loanID && selectedRole !== roleType.borrower) {
          attachmentCategories.push(
            { title: "FPI", filter: "FPI" },
            { title: "Notifications of Deposits", filter: "Notification of" },
            { title: "Servicing Agreement", filter: "Servicing Agreement" }
          );
        }

        if (loanID || selectedRole === roleType.borrower) {
          attachmentCategories.push(
            { title: "Late Notices", filter: "late notice" },
            { title: "NSF", filter: "nsf" }
          );
        }

        const otherFilter = attachmentCategories.map((cat) => cat.filter);

        const other = resp.filter(
          (item) =>
            !otherFilter.some((filter) =>
              item["Attachment"]?.title
                ?.toLowerCase()
                .includes(filter.toLowerCase())
            )
        );

        setAttachments(
          attachmentCategories
            .map(({ title, filter }) => ({
              title,
              list: filterAttachmentsByTitle(filter),
              open: false,
            }))
            .concat({ title: "Other", list: other, open: false })
        );
      } catch (error) {
        console.error("Error fetching attachments:", error);
      }
    };

    fetchAttachments();
  }, [loanID, accountId, selectedRole]);

  const processAttachments = (attachmentsData) => {
    const processedAttachments = attachmentsData.map((data) => {
      const htmlObject = document.createElement("div");
      htmlObject.innerHTML = data.attachment;
      const titleValue = removeSpanTag(
        htmlObject?.getElementsByTagName("a")?.[0]?.innerHTML
      );
      const hrefValue = updateLinkURLNew(
        htmlObject?.getElementsByTagName("a")?.[0]?.getAttribute("href")
      );
      data.Attachment = { href: hrefValue, title: titleValue };
      return data;
    });

    const filterAttachmentsByTitle = (title) =>
      processedAttachments.filter((item) =>
        item["Attachment"].title.toLowerCase().includes(title.toLowerCase())
      );

    const attachmentCategories = [
      { title: "Statement Of Account", filter: "Statement" },
      { title: "FPI quote", filter: "FPI quote" },
      { title: "Notifications of Deposits", filter: "Notification of" },
      { title: "Servicing Agreement", filter: "Servicing Agreement" },
    ];

    if (loanID) {
      attachmentCategories.push(
        { title: "Late Notices", filter: "late notice" },
        { title: "NSF", filter: "nsf" }
      );
    }

    const otherFilter = attachmentCategories.map((cat) => cat.filter);

    const other = processedAttachments.filter(
      (item) =>
        !otherFilter.some((filter) =>
          item["Attachment"].title.toLowerCase().includes(filter.toLowerCase())
        )
    );

    return attachmentCategories
      .map(({ title, filter }) => ({
        title,
        list: filterAttachmentsByTitle(filter),
        open: false,
      }))
      .concat({ title: "Other", list: other, open: false });
  };

  const toggleCategoryOpen = (title) => {
    setAttachments((currentCategories) =>
      currentCategories.map((category) =>
        category.title === title
          ? { ...category, open: !category.open }
          : category
      )
    );
  };

  const filteredAttachments = attachments?.flatMap((item) =>
    item.list.filter((listItem) =>
      listItem["Attachment"]?.title
        ?.toLowerCase()
        .includes(searchQuery?.toLowerCase())
    )
  );

  const handleClick = async (data) => {
    const attachmentsUrl = await fetchAttachmentData(data);
    // window.open(attachmentsUrl);
    const link = document.createElement("a");
    link.href = attachmentsUrl;
    link.target = "_blank"; // Opens in new tab
    link.rel = "noopener noreferrer"; // Security best practices
    document.body.appendChild(link); // Required for Firefox
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      style={{ padding: "20px" }}
      className="bg-white rounded attachments-table"
    >
      <section>
        <div>
          <div className="d-lg-flex justify-content-lg-between">
            <div className="d-flex flex-column">
              <p className="p-0 m-0 fs-4 fw-bold">Attachments</p>
              <p className="fw-light fs-6 text-black-50">
                {filteredAttachments?.length} Documents
              </p>
            </div>
            <div className="d-flex flex-sm-column flex-lg-row">
              <div className="me-lg-3 me-sm-0">
                <div className="input-group mb-3">
                  <span
                    className="input-group-text input-icon"
                    id="basic-addon1"
                  >
                    <Search />
                  </span>
                  <input
                    type="text"
                    className="form-control search-input"
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
              </div>
              {showUploadMore ? (
                <div className="d-sm-flex d-lg-block justify-content-sm-end my-sm-4 my-lg-0">
                  <Button
                    className="up-btn"
                    variant="outline-primary"
                    onClick={() => {
                      setShowPopup(true);
                    }}
                  >
                    + Upload More
                  </Button>
                  {showPopup && (
                    <PopupWrapper
                      title={
                        <h2 className="p-4 font-weight-bold text-dark">
                          Add Attachments
                        </h2>
                      }
                      Component={
                        <div>
                          {" "}
                          <CreateTicketWithAttachments
                            close={() => setShowPopup(false)}
                          />
                        </div>
                      }
                      toShow={showPopup}
                      closeEventHandler={() => {
                        setShowPopup(false);
                      }}
                    />
                  )}
                </div>
              ) : null}
            </div>
          </div>
          {attachments.map((item, index) => (
            <div key={index} className="d-flex flex-column mb-5">
              <div
                className="p-4 mb-4 d-flex justify-content-between align-items-center rounded-2"
                style={{ backgroundColor: "#00000022", cursor: "pointer" }}
                onClick={() => toggleCategoryOpen(item.title)}
              >
                <div>{item.title}</div>
                <svg
                  height="20"
                  width="20"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                  focusable="false"
                  className="css-tj5bde-Svg"
                >
                  <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                </svg>
              </div>
              {(item.open || searchQuery !== "") &&
                (item.list?.length &&
                item.list.filter((listItem) =>
                  listItem["Attachment"]?.title
                    ?.toLowerCase()
                    .includes(searchQuery?.toLowerCase())
                )?.length > 20 ? (
                  <PaginatedTable
                    data={item.list.filter((listItem) =>
                      listItem["Attachment"]?.title
                        ?.toLowerCase()
                        .includes(searchQuery?.toLowerCase())
                    )}
                    rowsPerPage={20}
                  />
                ) : (
                  <Table>
                    <tbody>
                      {item.list?.length ? (
                        item.list
                          .filter((listItem) =>
                            listItem["Attachment"]?.title
                              ?.toLowerCase()
                              .includes(searchQuery?.toLowerCase())
                          )
                          .map((listItem, index) => (
                            <tr key={index} className="m-5">
                              <td
                                style={
                                  isLargeDevice ? { minWidth: "28rem" } : null
                                }
                              >
                                <div className="d-flex">
                                  <ReportsAndDocumentsIcon />
                                  <div>
                                    <BlurWrapper>
                                      <div
                                        role="button"
                                        className="linkClick cursor-pointer text-decoration-underline"
                                        onClick={
                                          !isDemoAccount
                                            ? () => handleClick(listItem)
                                            : null
                                        }
                                      >
                                        {listItem["Attachment"].title}
                                      </div>
                                    </BlurWrapper>
                                  </div>
                                </div>
                              </td>
                              <td className="text-black-50">
                                {moment(new Date(listItem["date"])).format(
                                  "MMM DD, yyyy"
                                )}
                              </td>
                              <td className="text-black-50">PDF</td>
                              <td>
                                <Button
                                  className="down-btn"
                                  onClick={
                                    !isDemoAccount
                                      ? () => handleClick(listItem)
                                      : null
                                  }
                                >
                                  <DownloadIcon /> Download
                                </Button>
                              </td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td>No Data</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                ))}
            </div>
          ))}
        </div>
      </section>
      <style>
        {`
          .input-icon{
              background-color: rgba(0, 0, 0, 0.133);
              border: none;
          }
          .search-input{
              border: none;
              background-color: rgba(0, 0, 0, 0.133);
              padding:8px;
              border-radius:5px;
              width:20rem !important;
              margin-left: 0px !important;
          }
          .down-btn{
              background: #F0F6FF;
              color: #438FFF;
              border: none;
          }
          .up-btn{
            background: #FFF;
            color: #438FFF;
            border-color:#438FFF;
          }
        `}
      </style>
    </div>
  );
};

export default AttachmentsTab;

export const PaginatedTable = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const isDemoAccount = useSelector((state) => state.account.isDemoAccount);

  // Calculate the index of the last item on the current page
  const indexOfLastItem = currentPage * rowsPerPage;
  // Calculate the index of the first item on the current page
  const indexOfFirstItem = indexOfLastItem - rowsPerPage;
  // Get the current items based on the current page
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const pagesCount = Math.ceil(data?.length / rowsPerPage);
  let isPageNumberOutOfRange = false;

  const onPageNumberClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const pageNumbers = [...new Array(pagesCount)].map((_, index) => {
    const pageNumber = index + 1;
    const isPageNumberFirst = pageNumber === 1;
    const isPageNumberLast = pageNumber === pagesCount;
    const isCurrentPageWithinTwoPageNumbers =
      Math.abs(pageNumber - currentPage) <= 2;

    if (
      isPageNumberFirst ||
      isPageNumberLast ||
      isCurrentPageWithinTwoPageNumbers
    ) {
      isPageNumberOutOfRange = false;
      return (
        <Pagination.Item
          key={pageNumber}
          onClick={() => onPageNumberClick(pageNumber)}
          active={pageNumber === currentPage}
        >
          {pageNumber}
        </Pagination.Item>
      );
    }

    if (!isPageNumberOutOfRange) {
      isPageNumberOutOfRange = true;
      return <Pagination.Ellipsis key={pageNumber} className={classes.muted} />;
    }

    return null;
  });
  const handleChange = (e) => {
    onPageNumberClick(1);
    setRowsPerPage(e.target.value);
  };
  const handleClick = async (data) => {
    const attachmentsUrl = await fetchAttachmentData(data);
    // window.open(attachmentsUrl);
    const link = document.createElement("a");
    link.href = attachmentsUrl;
    link.target = "_blank"; // Opens in new tab
    link.rel = "noopener noreferrer"; // Security best practices
    document.body.appendChild(link); // Required for Firefox
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <Table>
        <tbody>
          {currentItems.map((listItem, index) => (
            <tr key={index} className="m-5">
              <td style={{ minWidth: "28rem" }}>
                <div className="d-flex">
                  <ReportsAndDocumentsIcon />
                  <div>
                    <BlurWrapper>
                      <div
                        role="button"
                        className="linkClick cursor-pointer text-decoration-underline"
                        onClick={
                          !isDemoAccount ? () => handleClick(listItem) : null
                        }
                      >
                        {listItem["Attachment"]?.title}
                      </div>
                    </BlurWrapper>
                  </div>
                </div>
              </td>
              <td className="text-black-50">
                {moment(new Date(listItem["date"])).format("MMM DD, yyyy")}
              </td>
              <td className="text-black-50">PDF</td>
              <td>
                <Button
                  className="down-btn"
                  onClick={!isDemoAccount ? () => handleClick(listItem) : null}
                >
                  <DownloadIcon /> Download
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div
        className="d-flex justify-content-center align-items-center mt-3"
        style={{ gap: "36px" }}
      >
        <p>
          Page {currentPage} of {pagesCount}
        </p>
        <Pagination className={classes.pagination}>
          <Pagination.Prev
            onClick={() => onPageNumberClick(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {pageNumbers}
          <Pagination.Next
            onClick={() => onPageNumberClick(currentPage + 1)}
            disabled={currentPage === pagesCount}
          />
        </Pagination>
        <div style={{ marginTop: "-10px" }}>
          <select className="p-3" value={rowsPerPage} onChange={handleChange}>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
    </>
  );
};

